import styled from 'styled-components';

import { breakpoints, Col } from '@notino/react-styleguide';

import { LoyaltyBanner } from '@sharedComponents/Loyalty';

export const SLoyaltyBannerWrapper = styled(Col)`
  padding: 0;
  margin-bottom: 1rem;
`;

export const SLoyalty = styled(LoyaltyBanner)`
  margin-top: 0.5rem;
`;

export const SWrapper = styled.div`
  width: 100%;

  @media (min-width: ${breakpoints.md}) {
    margin-right: 5.625rem;
  }
`;
